import { ShareFileRecordDialog } from "@/action-dialog/dialogs/ShareFileRecordDialog";
import type { FileRecord } from "@cohesive/api-client";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type ShareFileRecordCallableProps = {
  record: FileRecord;
};

export const ShareFileRecordCallable = createCallable<
  ShareFileRecordCallableProps,
  boolean
>(({ call, record }) => {
  return (
    <ShareFileRecordDialog record={record} onClose={() => call.end(false)} />
  );
}, UNMOUNTING_DELAY_MS);

ShareFileRecordCallable.displayName = "ShareFileRecordCallable";
